import React from 'react'

function Rules() {
    return (
        <div className='rules_container'>
            <div>
                <p>guess exact for 2 numbers, 3 numbers, and 4 numbers</p>
                <p>Format Taruhan: nomor1*nomor2*nomor3#bet+
                    nomor1*nomor2#bet</p>
                <p>Contoh Penulisan: 123*1234*12#5+11*  222*333#1+33*777#2</p>
            </div>
            <div className='rules_conversion'>
                <p>Konversi <br /> 1 = 1,000</p>
            </div>
        </div>
    )
}

export default Rules